import type { Organization } from '#/domain/organization/Organization'
import {
  isInvalidOrganization,
  type InvalidOrganization,
} from '#/domain/organization/InvalidOrganization'
import type { OrganizationRepository } from '#/domain/organization/OrganizationRepository'

export class FindAllOrganizationsUseCase {
  constructor(private readonly repository: OrganizationRepository) {}

  async execute(): Promise<Organization[]> {
    const items = await this.repository.findEvery()
    return items.filter((item): item is Organization => !isInvalidOrganization(item))
  }

  executeIncludingInvalid(): Promise<(Organization | InvalidOrganization)[]> {
    return this.repository.findEvery()
  }
}
